import { type JSX } from 'react';

import { CloseIcon } from '@cx-modules/ui';

import { useBookmakerFromCode } from '../../hooks/useBookmakerFromCode';
import { useOffersSignUpBookie } from '../../hooks/useOffersSignUpBookie';
import { useOffersSpecialBookie } from '../../hooks/useOffersSpecialBookie';
import { OffersList } from '../OffersList';

import { OffersDialogCloseBtn, OffersDialogWrapper } from './style';
export const OffersDialog = ({
  bookieCode,
  onCloseClicked,
}: {
  bookieCode: string;
  onCloseClicked: () => void;
}): JSX.Element => {
  const bookmaker = useBookmakerFromCode(bookieCode);
  const signupOffers = useOffersSignUpBookie(bookieCode);
  const specialOffers = useOffersSpecialBookie(bookieCode);

  return (
    <OffersDialogWrapper>
      <OffersDialogCloseBtn onClick={onCloseClicked}>
        <CloseIcon />
      </OffersDialogCloseBtn>
      {typeof bookmaker !== 'undefined' && (signupOffers || []).length > 0 && (
        <OffersList bookmaker={bookmaker} offers={signupOffers} />
      )}
      {typeof bookmaker !== 'undefined' && (specialOffers || []).length > 0 && (
        <OffersList bookmaker={bookmaker} offers={specialOffers} />
      )}
    </OffersDialogWrapper>
  );
};
